import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../../store/actions/userActions";
import AuthFrame from "./AuthFrame";
import { TitleBlock, Actions, PrimaryBtn, TextBtn } from "./pieces";
import { landingPathFor } from "./landingPath";

// /unauthorized: where the route guard sends an account that lacks the role
// (or the plan) a page needs. Signed in, it offers the account's own home
// and a way to switch accounts; signed out, a way to log in.
const UnauthorizedPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const permissions = useSelector((state) => state.user?.user?.permissions);
  const signedIn = !!localStorage.getItem("token");

  const goHome = () => navigate(landingPathFor(permissions) || "/", { replace: true });
  const logOut = () => {
    dispatch(logout());
    navigate("/login", { replace: true });
  };

  return (
    <AuthFrame phoneLogo>
      <TitleBlock
        tone="critical"
        eyebrow="No access"
        title="You cannot open this page"
        sub={signedIn
          ? "Your account does not have access to this page."
          : "Log in with an account that has access to this page."}
      />
      <Actions>
        {signedIn ? (
          <>
            <PrimaryBtn onClick={goHome}>Go to my home</PrimaryBtn>
            <TextBtn onClick={logOut}>Log out</TextBtn>
          </>
        ) : (
          <PrimaryBtn onClick={() => navigate("/login")}>Log in</PrimaryBtn>
        )}
      </Actions>
    </AuthFrame>
  );
};

export default UnauthorizedPage;
